import i18next from 'i18next';

import { graphSettings } from '@/config/settings';
import type { HealthTrendPoint } from '@/domain/health';

import { toHealthPercent } from '../../_utils/healthDetailOverviewHelpers';
import type { HealthDevelopmentDataset } from '../../HealthDashboard/healthDevelopmentChartHelpers';

/**
 * Same palette as the Status bars beside it, so a score keeps its colour across both
 * cards. The dashboard development chart uses `HEALTH_DEVELOPMENT_CHART_COLORS` instead.
 */
const SCORE_SERIES = [
    { labelKey: 'score_1', metricsKey: 'score1', color: graphSettings.laksvel.score_1 },
    { labelKey: 'score_2', metricsKey: 'score2', color: graphSettings.laksvel.score_2 },
    { labelKey: 'score_3', metricsKey: 'score3', color: graphSettings.laksvel.score_3 },
] as const;

export function hasHealthTrendChartData(trend: HealthTrendPoint[]): boolean {
    if (trend.length === 0) {
        return false;
    }

    return trend.some(
        (point) =>
            toHealthPercent(point.score1) != null ||
            toHealthPercent(point.score2) != null ||
            toHealthPercent(point.score3) != null
    );
}

/** One percent series per score, in the shape `buildHealthDevelopmentChartSpec` takes. */
export function mapHealthTrendToDevelopmentDatasets(
    trend: HealthTrendPoint[]
): HealthDevelopmentDataset[] {
    return SCORE_SERIES.map(({ labelKey, metricsKey, color }) => ({
        label: i18next.t(`scores.${labelKey}`) as string,
        color,
        data: trend.map((point) => ({
            day: point.day,
            value: toHealthPercent(point[metricsKey]),
        })),
    }));
}
